import { Component, EventEmitter, Input, Output } from '@angular/core';

const MONTH_NAMES = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

/** Botón tipo "pill" ("Este mes" + flecha) que despliega un selector de
 * AÑO y MES (grid de 12 meses + navegación de año) — como el selector de
 * día tipo calendario ya usado en Pagos a proveedores, pero para elegir un
 * mes completo en vez de un día del mes. Se usa en los mini-paneles de
 * ranking, donde el periodo relevante es "qué mes mirar", no un rango de
 * días arbitrario (eso lo cubre app-date-range-picker en los filtros
 * principales). */
@Component({
    selector: 'app-month-picker',
    templateUrl: './month-picker.component.html',
    styleUrls: ['./month-picker.component.css'],
    host: { '(document:click)': 'onDocumentClick($event)' }
})
export class MonthPickerComponent {
    @Input() year = new Date().getFullYear();
    @Input() month = new Date().getMonth();
    @Output() yearChange = new EventEmitter<number>();
    @Output() monthChange = new EventEmitter<number>();
    @Output() periodApplied = new EventEmitter<void>();

    readonly monthNames = MONTH_NAMES;

    open = false;
    draftYear = this.year;
    draftMonth = this.month;

    get label(): string {
        return `${MONTH_NAMES[this.month]} ${this.year}`;
    }

    toggle(): void {
        if (!this.open) {
            this.draftYear = this.year;
            this.draftMonth = this.month;
        }
        this.open = !this.open;
    }

    prevYear(): void {
        this.draftYear--;
    }

    nextYear(): void {
        this.draftYear++;
    }

    selectMonth(m: number): void {
        this.draftMonth = m;
    }

    apply(): void {
        this.year = this.draftYear;
        this.month = this.draftMonth;
        this.yearChange.emit(this.year);
        this.monthChange.emit(this.month);
        this.open = false;
        this.periodApplied.emit();
    }

    onDocumentClick(event: MouseEvent): void {
        if (!this.open) return;
        const target = event.target as HTMLElement;
        if (!target.closest('app-month-picker')) {
            this.open = false;
        }
    }
}
